<section class="go-container">

    <go-card class="go-column go-column--100" id="implementing-details">
      <ng-container go-card-header>
        <h2 class="go-heading-2 go-heading--no-wrap">Implementing Details</h2>
        <go-copy cardId="implementing-details" goCopyCardLink></go-copy>
      </ng-container>
      <ng-container go-card-content>
        <p class="go-body-copy go-body-copy--no-margin">
          Sometimes within a table row we might need more details then we can fit in the row. This is where the table details comes
          into play. This provides a dropdown for each table row that when opened can provide more details about the item in the row.
          With the table details component we allow the implementor to provide a template to use for each drop down and then we inject
          that template into the correct place in the interface.
        </p>
      </ng-container>
    </go-card>
  
    <go-card class="go-column go-column--100" id="details-template">
      <ng-container go-card-header>
        <h2 class="go-heading-2 go-heading--no-wrap">Details Template</h2>
        <go-copy cardId="details-template" goCopyCardLink></go-copy>
      </ng-container>
      <ng-container go-card-content>
        <p class="go-body-copy">
          Inside of the <code class="code-block--inline">go-table-details</code> component is where a 
          <code class="code-block--inline">ng-template</code> with a template ref of 
          <code class="code-block--inline">#goTableDetails</code> is used to specify what code we are dropping 
          into the details section. The object in the row can be accessed through <code class="code-block--inline">item</code>
          if <code class="code-block--inline">let-item</code> is used as an attribute on the ng-template.
        </p>

        <code [highlight]="tableDetailsExample"></code>
      </ng-container>
    </go-card>

    <go-table
      class="go-column go-column--100"
      [tableConfig]="tableDetailsConfig"
      tableTitle="Table Details">
      <go-table-column field="id" title="ID"></go-table-column>
      <go-table-column field="name.first" title="First Name"></go-table-column>
      <go-table-column field="name.last" title="Last Name"></go-table-column>
      <go-table-column field="ip_address" title="IP Address"></go-table-column>
      <ng-template #goTableDetails let-item>
        <div>Email: <a class="go-link" href="mailto:{{ item.email }}">{{ item.email }}</a></div>
        <div>Gender: {{ item.gender }}</div>
      </ng-template>
    </go-table>

    <go-card class="go-column go-column--100" id="using-a-component">
      <ng-container go-card-header>
        <h2 class="go-heading-2 go-heading--no-wrap">Using a component</h2>
        <go-copy cardId="using-a-component" goCopyCardLink></go-copy>
      </ng-container>
      <div class="go-container" go-card-content>

        <div class="go-column go-column--100">
          <p class="go-body-copy">
            If there are a lot of details on a row that we don't want to load unless someone clicks on the row
            we can accomplish this through a component. Putting a component inside of the template will allow us
            to do something like use the id of the row to get results from the backend and only preload the items
            that will actually show up in the columns. In the example below we are passing the row into a component
            and then loading some results and then showing those results in the details section.
          </p>
  
          <code [highlight]="tableDetailsComponentExample"></code>
        </div>

        <div class="go-column go-column--50">
          <h1 class="go-heading-6">Table Details Test Component</h1>
          <code [highlight]="testComponent"></code>
        </div>
        <div class="go-column go-column--50">
          <h1 class="go-heading-6">Table Details Test HTML</h1>
          <code [highlight]="testComponentHtml"></code>
        </div>

      </div>
    </go-card>
  
    <go-table
      class="go-column go-column--100"
      [tableConfig]="tableDetailsConfig"
      tableTitle="Table Details">
      <go-table-column field="id" title="ID"></go-table-column>
      <go-table-column field="name.first" title="First Name"></go-table-column>
      <go-table-column field="name.last" title="Last Name"></go-table-column>
      <go-table-column field="ip_address" title="IP Address"></go-table-column>
      <ng-template #goTableDetails let-item>
        <app-table-details-test [row]="item"></app-table-details-test>
      </ng-template>
    </go-table>
  </section>
